import React from 'react';
import axios from 'axios';
import Navbar from '../Navbar';
import Footer from '../Footer';
import {
    WORDPRESS_URL,
    WP_POSTS_SLUG
} from "../../utils/constants";
import renderHTML from 'react-render-html';
import Preloader from "../Preloader";
import { Redirect, withRouter } from 'react-router-dom';
import kosodelnik from "../../images/kosodelnik.png";
import kosodelnikModry from "../../images/kosodelnik-modry.png";
import api from '../../Api';
import functions from '../../utils/functions';

class Contact extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            selectedContactCategory: 'GENERAL',
            bodyPost: {},
            isLoading: false,
            text: '',
            textError: "",
            firstname: '',
            firstnameError: "",
            lastname: '',
            lastnameError: "",
            phone: '',
            phoneError: "",
            email: '',
            captcha: '',
            captchaError: "",
            error: {},
            redirectInternalError: false,
            emailSendAlertClass: "alert-success",
            emailSendAlertText: "Váš dotaz byl úspěšně odeslán, děkujeme!",
            emailSendAlertDisplay: "d-none",
            emailSendButtonText: "Odeslat zprávu",
            emailSendButtonFa: "fa-chevron-right"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.validateField(event.target.name, event.target.value);

        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleBack = () => {
        const { history } = this.props;
        if (document.referrer && document.referrer.includes(window.location.hostname)) {
          history.goBack();
        } else {
          history.push('/'); // nebo jiná stránka
        }
      };

    handleSubmit(event) {
        const {firstname, lastname, phone, email, text, selectedContactCategory, captcha} = this.state;
        const recipients = functions.CategoryResponsibleEmails(selectedContactCategory);
        const companyWeb = "PRODECO, a.s.";
        
        setTimeout(() => this.setState({ 
                emailSendAlertDisplay: 'd-none',  
                emailSendButtonText: "Odeslat zprávu",
                emailSendButtonFa: "fa-chevron-right"
            }), 10000
        );

        this.validateForm();

        if(!firstname || !lastname || !text || !phone || Number.isNaN(Number.parseInt(phone, 10)) || !captcha || captcha.toLowerCase() !== 'slunce') {
            event.preventDefault();
            return;
        }

        this.setState({
            emailSendButtonText: "Odesílám zprávu",
            emailSendButtonFa: "fa-spinner fa-spin"
        });

        let emailObject = {
            Recipients: recipients,
            Subject: "Zpráva z kontaktního formuláře na webu " + companyWeb,
            CompanyWeb: companyWeb,
            FirstName: firstname,
            LastName: lastname,
            Phone: Number.parseInt(phone, 10).toString(),
            Email: email != null ? email : "nezadán",
            EmailText: text
        }

        api.contact.send(emailObject).then((response)=> {
            if (response.data) {
                console.log(response.data);
                this.setState({
                    emailSendButtonText: "Zpráva odeslána",
                    emailSendButtonFa: "fa-check",
                    emailSendAlertDisplay: "d-block",
                    firstname: "",
                    lastname: "",
                    phone: "",
                    email: "",
                    text: "",
                    captcha: ""    
                });
            } else {
                this.setState({
                    emailSendButtonText: "Zpráva neodeslána",
                    emailSendButtonFa: "fa-times",
                    emailSendAlertDisplay: "d-block",                    
                    emailSendAlertClass: "alert-danger",
                    emailSendAlertText: "Při odeslání formuláře došlo k chybě, zkuste to prosím později",
                });
            }            
        }).catch(() => {
            this.setState({
                emailSendButtonText: "Zpráva neodeslána",
                emailSendButtonFa: "fa-times",
                emailSendAlertDisplay: "d-block",                    
                emailSendAlertClass: "alert-danger",
                emailSendAlertText: "Při odeslání formuláře došlo k chybě, zkuste to prosím později",
            });
        });
        
    }

    validateForm = () => {
        const { firstname, lastname, phone, text, captcha } = this.state;

        this.validateField("firstname", firstname);
        this.validateField("lastname", lastname);
        this.validateField("phone", phone);
        this.validateField("text", text);
        this.validateField("captcha", captcha);
    }

    validateField = (fieldName, value) => {
        switch(fieldName) {
            case 'firstname':      
                if(!value) {
                    this.setState({firstnameError: "contact-form-shadow-error"});
                } else {
                    this.setState({firstnameError: ""});
                }     

                break;
            case 'lastname':            
                if(!value) {
                    this.setState({lastnameError: "contact-form-shadow-error"});
                } else {
                    this.setState({lastnameError: ""});
                }    

                break;
            case 'phone':                        
                if(!value || Number.isNaN(Number.parseInt(value, 10))) {
                    this.setState({phoneError: "contact-form-shadow-error"});
                } else {
                    this.setState({phoneError: ""});
                }    

                break;
            case 'text':                  
                if(!value) {
                    this.setState({textError: "contact-form-shadow-error"});
                } else {
                    this.setState({textError: ""});
                }  

                break;
            case 'captcha':                  
                if(!value || value.toLowerCase() !== 'slunce') {
                    this.setState({captchaError: "contact-form-shadow-error"});
                } else {
                    this.setState({captchaError: ""});
                }  

                break;
          default:
            break;
        }
      }

    renderHeader = () => {
        return(
            <header className="contact-header">
            <div className="header-overlay">
                <Navbar/>
    
                <div className="sd-container">
                    <section id="section-sub-header">
                            <div className="col-md-12 d-flex justify-content-between section-title"> 
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="sub-header-caption text-uppercase title-border-radius link">Kontakty</h6>
                                    </div>
                                <span className='back-button link' onClick={this.handleBack}><i className='fa ml-2 fa-chevron-left'></i> Zpět</span>          
                            </div>                        
                    </section>
                </div>
                </div>
            </header> 
        );
    }
    
    renderMainContainer = () => {        
        const { emailSendAlertClass, emailSendAlertText, emailSendAlertDisplay, emailSendButtonText, emailSendButtonFa } = this.state;


        return(
            <section id="main-container" className="mb-5">
                <div className="sd-container">
                    <section id="section-text" className=' font-weight-bold'>Napište nám zprávu a my se vám obratem ozveme.</section>
                <section id="contact-form">
                        <div className="mt-4 contact-form-shadow">
                            <div className="p-3 w-100">
                                <div className={["alert no-radius", emailSendAlertClass, emailSendAlertDisplay].join(' ')} role="alert">
                                    {emailSendAlertText}
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="firstname" className="font-weight-bold">Jméno</label>
                                        <input type="text" name="firstname" value={this.state.firstname} onChange={this.handleChange} className={["form-control contact-form-input contact-form-shadow", this.state.firstnameError].join(' ')} id="firstname"/>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="lastname" className="font-weight-bold">Příjmení</label>
                                        <input type="text" name="lastname" value={this.state.lastname} onChange={this.handleChange} className={["form-control contact-form-input contact-form-shadow", this.state.lastnameError].join(' ')} id="lastname"/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="phone" className="font-weight-bold">Telefon</label>
                                        <input type="text" name="phone" value={this.state.phone} onChange={this.handleChange} className={["form-control contact-form-input contact-form-shadow", this.state.phoneError].join(' ')} id="phone"/>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="email" className="font-weight-bold">Email</label>
                                        <input type="text" name="email" value={this.state.email} onChange={this.handleChange} className={["form-control contact-form-input contact-form-shadow"].join(' ')} id="email"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="text" className="font-weight-bold">Vaše zpráva</label>
                                    <textarea name="text" value={this.state.text} onChange={this.handleChange} className={["form-control radius-0 contact-form-shadow", this.state.textError].join(' ')} id="text" cols="30" rows="5"></textarea>                
                                </div>

                                <div className="form-group">
                                    <label htmlFor="text" className="font-weight-bold">Ochrana proti spamu</label>
                                    <input type="text" name="captcha" placeholder="Žlutá koule na obloze" value={this.state.captcha} onChange={this.handleChange} className={["form-control radius-0 contact-form-input contact-form-shadow", this.state.captchaError].join(' ')} id="captcha" />
                                </div>
                                    
                                <button type="submit" className="trapezoid sd-pointer" onClick={this.handleSubmit}>
                                    <span>
                                        {emailSendButtonText} <i className={["fa ml-2", emailSendButtonFa].join(' ')}></i>
                                    </span>
                                </button>                                
                            </div>
                        </div>
                    </section>

                    <section id="detail-contact" className="pb-3 pt-3 mt-3">
                        
                    <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className="pt-4 pb-2 font-weight-bold">E-mail</div>
                                    <div>prodeco@prodeco.cz</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className="pt-4 pb-2 font-weight-bold">Provoz Bílina</div>
                                    <div> Důlní 437, Mostecké Předměstí</div>
                                    <div> Bílina, 418 01</div>
                                    <br/>
                                    <div> +420 417 804 911</div>
                            </div>
                        </div>
    
                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className="font-weight-bold pt-4 pb-2">Provoz Tušimice</div>
                                    <div> Tušimice 24</div>
                                    <div>Kadaň, 432 01</div>
                                    <br/>
                                    <div> +420 474 604 370</div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className="font-weight-bold pt-4 pb-2">Odbor Obchodu a Inženýringu</div>
                                    <div>obchod@prodeco.cz</div>                                 
                                    <br/>
                                    <div>Roman Hřebík</div>
                                    <div> +420 777 784 914</div>
                                    <br/>
                                    <div>Stanislav Galík</div>
                                    <div> +420 728 869 122</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className="font-weight-bold pt-4 pb-2">Odbor Hydraulika</div>
                                    <div> Mládežnická 343</div>
                                    <div>Bílina, 418 01</div>
                                    <br/>
                                    <div>Ing. Václav Viktora</div>
                                    <div> +420 725 845 896</div>
                            </div>
                        </div>

                        
                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className=" font-weight-bold pt-4 pb-2">Odbor Elektro ASŘ</div>
                                    <div> Areál Doly Nástup Tušimice</div>
                                    <div>Březno u Chomutova, 431 45</div>
                                    <br/>
                                    <div>Alena Pelešková</div>
                                    <div> +420 724 087 214 </div>
                            </div>
                        </div>

                          
                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className=" font-weight-bold pt-4 pb-2">Mzdová účtárna</div>
                                    <div> +420 417 804 909</div>
                                    <div> +420 417 804 908</div>
                            </div>
                        </div>

                          
                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row mb-3 ml-2">
                            <div className="col-12 d-flex justify-content-between direction-column">
                                    <div className=" font-weight-bold pt-4 pb-2">Finanční účtárna</div>
                                    <div> +420 417 804 942</div>
                                    <div> +420 417 804 943</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        );
    }
    
    renderFooter = () => {
        return(
            <footer className="footer-section-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>           
        );
    }
    
    render(){
        const { isLoading, redirectInternalError, error } = this.state;
    
        return (            
            <section id="web">
                {isLoading ? (
                    <Preloader isLoaded={!isLoading} />
                ) : (redirectInternalError ? (
                    <Redirect to={{
                        pathname: "/500",
                        state: { error: error }
                      }} />
                ) : ( 
                    <div className="wrapper">
                        {this.renderHeader()}
    
                        {this.renderMainContainer()}
    
                        {this.renderFooter()}
                    </div>
                ))}
            </section>        
        )
    }
}

export default withRouter(Contact);